import Actions from '../Actions/Actions'
import { Loading } from '../common'
import { ItemThumbs } from '../item'
import usePOI from './usePOI'
import { BodyContent, FooterContent, HeaderContent } from '../content'
import DebugJson from '../debug/DebugJson/DebugJson'
import { Typography } from '@mui/material'
import { Copy, CopyContainer } from '../common/copy'
import LeadLocked from '../LeadLocked/LeadLocked'
import LeadCopy from '../LeadCopy/LeadCopy'

interface POIProps {
  poiId: string
}

const POI = (props: POIProps) => {
  const { poiId } = props
  const { poi, actions, itemsFound, content, loading, error } = usePOI({
    poiId,
  })
  const { filePath, parentMeta } = content || {}

  const scene = poi?.scene
  const {
    name: sceneName,
    prefix: scenePrefix,
    title: sceneTitle,
    subTitle: sceneSubtitle,
    header,
    body,
    footer,
  } = scene || {}

  if (error) return <div>Error loading POI: {error}</div>
  if (!poi && !loading) return <div>POI not found</div>

  const name = sceneName
    ? `${scenePrefix ?? ''}${sceneName}`
    : `${poi?.prefix ?? ''}${poi?.name ?? ''}`

  // prettier-ignore
  return (
    <Loading loading={loading} fullscreen message='Loading POI...'>
      
      {header?.content && <HeaderContent parentMeta={parentMeta} filePath={filePath} contentBlock={header} />}

      {/* <Breadcrumbs /> */}

      {poi?.locked && <LeadLocked />}

      <LeadCopy name={name} title={sceneTitle} subTitle={sceneSubtitle} />

      {itemsFound && <CopyContainer padding={{ right: 'xsmall', left: 'small', top: 'xsmall', bottom: 'small', }}>
        <Typography variant="h4">You found:</Typography>
        <ItemThumbs items={scene?.items} />
      </CopyContainer>}

      <Actions actions={actions} />

      {body?.content && <CopyContainer padding='large' topBottom={true}>
        <BodyContent parentMeta={parentMeta} filePath={filePath} contentBlock={body}  />
      </CopyContainer>}

      {footer?.content && <FooterContent parentMeta={parentMeta} filePath={filePath} contentBlock={footer} />}
      

      <DebugJson json={poi} />
      
    </Loading>
  )
}

export default POI
